var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed, nextTick, ref, watch } from "vue";
import { isWorkflowInput } from "@/components/Workflow/constants";
import WorkflowInvocationStep from "@/components/WorkflowInvocationState/WorkflowInvocationStep.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationSteps',
    props: {
        steps: null,
        storeId: null,
        invocation: null,
        workflow: null,
        hideGraph: { type: Boolean, default: true },
        showingJobId: null,
        isFullPage: { type: Boolean },
        activeNodeId: { default: undefined }
    },
    emits: ["focus-on-step", "update:showing-job-id"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faChevronDown, faChevronUp, faSignInAlt);
        const stepsDiv = ref();
        const workflowInputSteps = Object.values(props.workflow.steps).filter((step) => isWorkflowInput(step.type));
        const oneOrNoInput = computed(() => workflowInputSteps.length <= 1);
        const expandInvocationInputs = ref(oneOrNoInput.value);
        watch(() => [props.activeNodeId, stepsDiv.value], ([nodeId, card]) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            // if the active node id is an input step, expand the inputs section if not already expanded
            if (!expandInvocationInputs.value) {
                const isAnInput = workflowInputSteps.findIndex((step) => step.id === props.activeNodeId) !== -1;
                expandInvocationInputs.value = isAnInput;
            }
            yield nextTick();
            // on full page view, scroll to the active step card in the steps section
            if (props.isFullPage) {
                if (nodeId !== undefined && card) {
                    // scroll to the active step card
                    const stepCard = (_a = stepsDiv.value) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-index="${props.activeNodeId}"]`);
                    stepCard === null || stepCard === void 0 ? void 0 : stepCard.scrollIntoView({ block: "nearest", inline: "start" });
                }
            }
            // clear any job being shown
            emit("update:showing-job-id", undefined);
        }), { immediate: true });
        function showJob(jobId) {
            emit("update:showing-job-id", jobId);
        }
        return { __sfc: true, emit, props, stepsDiv, workflowInputSteps, oneOrNoInput, expandInvocationInputs, showJob, faChevronDown, faChevronUp, faSignInAlt, FontAwesomeIcon, isWorkflowInput, WorkflowInvocationStep };
    }
});
